import config from '../config/env';

const API_BASE_URL = config.API_BASE_URL;

// 通用请求函数
const request = async (url: string, options: RequestInit = {}) => {
  const token = localStorage.getItem('accessToken');
  
  const config: RequestInit = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    },
    credentials: 'include',
    ...options,
  };

  try {
    const response = await fetch(`${API_BASE_URL}${url}`, config);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || '请求失败');
    }
    
    return data;
  } catch (error) {
    console.error('API请求错误:', error);
    throw error;
  }
};

// 登录接口
export const login = async (username: string, password: string) => {
  return request('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ username, password }),
  });
};

// 获取用户信息
export const getUserInfo = async () => {
  return request('/user/info');
};

// 修改密码接口
export const changePassword = async (oldPassword: string, newPassword: string) => {
  return request('/user/change-password', {
    method: 'POST',
    body: JSON.stringify({ oldPassword, newPassword }),
  });
};

// 登出接口
export const logout = async () => {
  // 清除本地存储的token
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('userInfo');
};

export default {
  login,
  getUserInfo,
  logout,
};
